import { Alert } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import Modal from '../../elements/Modal';
import ExpertAdviceForm from './ExpertAdviceForm';
import DeleteExpertAdvice from './DeleteExpertAdvice';

const EditExpertAdvice = ({
  data,
  fetchData,
  setMessage,
  setSnackbarOpen,
  token,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    const formData = new FormData();
    const expertName =
      values.name.charAt(0).toUpperCase() + values.name.slice(1);
    formData.append('name', expertName);
    formData.append('description', values.description);
    formData.append('image', values.image);
    formData.append('designation', values.designation);
    formData.append('tiktokId', values.tiktokId);
    formData.append('twitterId', values.twitterId);
    formData.append('instagramId', values.instagramId);
    formData.append('categoryId', data.id);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/experts/${data.expert.id}`,
        {
          method: 'PUT',
          body: formData,
          headers: { Authorization: token },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Expert updated successfully');
      fetchData(0);
      handleClose();
    } catch (err) {
      setError('Failed to update expert. ' + err.message);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleClickOpen}>
        Edit Expert
      </Button>
      <Modal
        open={open}
        modalTitle="Edit Expert"
        handleClose={handleClose}
        width="md">
        {error && <Alert severity="error">{error}</Alert>}
        <ExpertAdviceForm onSubmit={handleSubmit} data={data.expert} />
        <DeleteExpertAdvice
          data={data.expert}
          token={token}
          fetchData={fetchData}
        />
      </Modal>
    </>
  );
};

export default EditExpertAdvice;
